 <!--
    2019-2-13, AJK, created file
    2019-3-6, AJK, added ability to reset password
    2019-3-6, AJK, updated to use snotify
 -->

<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class="columns is-centered">
      <div id="card" class="column card-container is-full">
        <router-link :to="{name: 'dashboard'}">
          <button type="email" placeholder="email" class="button is-primary is-pulled-right">Back</button>
        </router-link>
        <h1 class="title">Thanks!</h1>
        <h2 class="title">Your order is now being processed. You Order Number is {{userInfo.orderNumber}}.</h2>
        <p>Shipping fees will be added to your order. </p>
        <br>
        <p>Thank you for shopping with Dean’s Beans, where high quality specialty coffee is a vehicle for positive change! </p>
        <br>
        <p>When you purchase from Dean’s Beans you are supporting: </p>
        <ul>
          <li>• Independent coffee roasting</li>
          <li>• Organic agriculture</li>
          <li>• Reforestation in Coffeelands where forests have been clear cut</li>
          <li>• Fair trade practices</li>
          <li>• Our award-winning people-centered development projects in coffee producing regions across the world</li>
        </ul>
        <br>
        <p>Change is brewing! </p>
        <br>
        <p>Cheers!</p>
        <p>-The Dean's Beans Team</p>

      </div>
    </div>
  </div>
</template>

<script>
import loginAPI from "@/api/LoginAPI.js";
import sharedAPI from "@/api/SharedAPI.js";
import store from "../store.js";
import { mapMutations, mapState } from "vuex";
import axios from "axios";

export default {
  name: "ThankYou",
  props: ["usernameProp"],
  data() {
    return {
      username: null,
      password: null,
      hash: null,
      errorMsg: null,
      isLoading: false,
      isFullPage: true,
      notificationDuration: 4000,
      perPage: 15,
      page: 1,
      products: [],
      productLines: [],
    };
  },

  filters: {
    currency: function(price){
      return "$".concat(price.toFixed(2));
    }
  },

  computed: {
    ...mapState(["userInfo"]),

    offset: function() {
      return this.page * this.perPage - (this.perPage - 1);
    }
  },

  methods: {
    ...mapMutations([
      "setCampaigns",
      "setEmails",
      "setCampaignsAndEmails",
      "setSelectedCampaign"
    ]),

    onPageChange(page) {
      this.page = page;
      this.loadData();
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.has-text-danger {
  padding-bottom: 20px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.card-container {
  padding: 2rem;
  margin: 0px 20px 20px 20px;
}
/*.field-container {*/
/*  background-color: #FFFFFF;*/
/*  border: solid 1px #cccccc;*/
/*  border-radius: 5px;*/
/*  padding: 2rem;*/
/*  margin: 0px 20px 20px 20px;*/
/*}  */
</style>
